export default __webpack_public_path__ + "static/media/it-55.023e884f.svg";